import { render, staticRenderFns } from "./ProductPageVideos.vue?vue&type=template&id=31912824&"
import script from "./ProductPageVideos.vue?vue&type=script&lang=js&"
export * from "./ProductPageVideos.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports